const metrics = new Set(["spend", "cv", "roas", "cpa", "revenue", "clicks", "impressions", "ctr", "cvr", "cpc", "cpm", "aov"]);
const str = value => typeof value === "string" && value.length <= 300;
const date = value => /^\d{4}-\d{2}-\d{2}$/.test(value || "") && Number.isFinite(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
export function validGoals(goals) {
  if (!Array.isArray(goals) || goals.length > 500) return false;
  const ids = new Set();
  return goals.every(g => {
    if (!g || typeof g !== "object" || !str(g.goal_id) || !g.goal_id || ids.has(g.goal_id)) return false;
    ids.add(g.goal_id);
    return str(g.campaign_name || "") && str(g.tag_id || "") && metrics.has(g.metric) && date(g.period_start) && date(g.period_end) && g.period_start <= g.period_end && ["string", "number"].includes(typeof g.target_value) && Number.isFinite(Number(g.target_value)) && Number(g.target_value) > 0 && (!g.campaign_scope || str(g.campaign_scope.source) && !!g.campaign_scope.source && str(g.campaign_scope.campaign_id) && str(g.campaign_scope.account_id));
  });
}
export function campaignScope(row) {
  return {
    source: String(row._media || row.source || "").toUpperCase(),
    campaign_id: String(row.campaign_id || ""),
    account_id: String(row.account_id || row.meta_account_id || "")
  };
}
export function campaignChoiceKey(row) {
  const s = row.campaign_scope || campaignScope(row);
  return JSON.stringify([s.source, s.account_id, s.campaign_id, s.campaign_id ? "" : row.campaign_name]);
}
export function campaignChoices(rows = []) {
  const map = new Map();
  for (const row of rows) if (row.campaign_name) {
    const scope = campaignScope(row);
    const key = campaignChoiceKey(row);
    if (!map.has(key)) map.set(key, {
      key,
      name: row.campaign_name,
      scope,
      label: `${row.campaign_name} · ${scope.source || "매체 미확인"}${scope.campaign_id ? ` · ${scope.campaign_id}` : ""}`
    });
  }
  return [...map.values()];
}
export function goalMatchesCampaign(goal, row, allRows = []) {
  if (!goal.campaign_name) return false;
  if (goal.campaign_scope) {
    const scope = campaignScope(row),
      expected = goal.campaign_scope;
    return scope.source === expected.source && scope.account_id === expected.account_id && (expected.campaign_id ? scope.campaign_id === expected.campaign_id : !scope.campaign_id && row.campaign_name === goal.campaign_name);
  }
  // Legacy names may only resolve when there is a single unambiguous candidate.
  return row.campaign_name === goal.campaign_name && campaignChoices(allRows.filter(r => r.campaign_name === goal.campaign_name)).length === 1;
}
export function ambiguousGoal(goal, rows = []) {
  return !!goal.campaign_name && !goal.campaign_scope && campaignChoices(rows.filter(r => r.campaign_name === goal.campaign_name)).length > 1;
}
